module.exports = __webpack_public_path__ + "static/product-dna-detail-5db247e78be16ce342f8464b4ea3b6ae.png";